<template>
  <v-container fluid>
    <v-tabs @change="updateEvent">
      <v-tab>Contracts</v-tab>
      <v-tab>Holidays</v-tab>
      <v-tab>Departments</v-tab>
      <v-tab>Users</v-tab>
      <v-tab-item>
        <Contract ref="Contract"></Contract>
      </v-tab-item>
      <v-tab-item>
        <PublicHoliday ref="PublicHoliday"></PublicHoliday>
      </v-tab-item>
      <v-tab-item>
        <Department ref="Department"></Department>
      </v-tab-item>
      <v-tab-item>
        <HumanUser ref="HumanUser"></HumanUser>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import Contract from "@/components/TimeTracker/Contract";
import PublicHoliday from "@/components/TimeTracker/PublicHoliday";
import HumanUser from "@/components/TimeTracker/HumanUser";
import Department from "@/components/TimeTracker/Department";

export default {
  name: 'HRConfig',
  props: {
    subtractHeight: {type: [Number], default: 150},
    height: {type: [Number], default: window.innerHeight},
  },

  components: {
    Contract,
    PublicHoliday,
    Department,
    HumanUser,
  },

  computed: {},

  methods: {
    onResize() {
      // this.windowHeight = (window.innerHeight - this.subheight) + 'px'
      // console.log(this.$refs)
      let topHeight = 10
      if (this.$refs.RefListTop)
        topHeight = this.$refs.RefListTop.$el.clientHeight
      let footerHeight = 10
      if (this.$refs.RefListFooter)
        footerHeight = this.$refs.RefListFooter.clientHeight
      this.windowHeight = (window.innerHeight - this.subtractHeight - topHeight - footerHeight) + "px"
      // console.log('this.windowHeight', this.windowHeight)
    },
    updateEvent(event) {
      // console.log('updateEvent', this.$refs, event)
      if (event === 0 && this.$refs.Contract) {
        this.$refs.timeTrackerEventFull.onUpdateFilters()
        return
      }
      if (event === 1 && this.$refs.PublicHoliday) {
        this.$refs.PublicHoliday.onUpdateFilters()
        return
      }
      if (event === 2 && this.$refs.Department) {
        this.$refs.Department.onUpdateFilters()
        return
      }
      if (event === 3 && this.$refs.HumanUser) {
        this.$refs.HumanUser.onUpdateFilters()
        return
      }
    },
  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize)
    this.onResize()
  },

  created() {
    window.addEventListener("resize", this.onResize);

  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  beforeDestroy() {
  },

  data: function () {
    return {
      windowHeight: (this.height - this.subheight) + 'px',
    }
  }
}

</script>

<style scoped lang="scss">

</style>
